import ethereum from "decentralized/ethereum.js"
import {getFormattedDate} from 'utils/date.js';
import {SAMPLE, PRESET} from 'constants/content-types.js';
import {getBlockDate} from 'utils/getBlockDate.js';
import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const CreateBy = ({content}) => { 
    let [contentName, setContentName] = useState('');
    let [userName, setUserName] = useState('');
    let [createdDate, setCreatedDate] = useState('');

    useEffect(() => {
        if (!content.isCreated()) {
            setCreatedDate('');
            setUserName('');
            return;
        }
        ethereum.users.getUserName(content.sampledByUser || content.user)
            .then(name => setUserName(name));
        getBlockDate(content.blockNumber)
            .then(date => {
                if (date) {
                    setCreatedDate(getFormattedDate(date));
                }
            });
    }, [setUserName, setCreatedDate, content.ipfsHash, content]);

    const saveContent = useCallback(() => {
        content.save(contentName);
    }, [content, contentName]);

    const onChange = useCallback((e) => {
        setContentName(e.target.value);
    }, [setContentName]);

    let creationWord = content.getContentType() === SAMPLE ?
        'sampled' : 'created';

    let creation = '';
    if (content.getContentType() === PRESET &&
        content.hasEdits) {
        creation = (
            <div className="needs-creation">
              <div className="info-text">You've edited this sound</div>
              <div className="name-input-container">
                <input
                  placeholder="Type new name for sound"
                  onChange={onChange}
                  value={contentName} type="text" className="preset-name-input"></input>
                <div
                  onClick={saveContent}
                  className={contentName === '' ? "preset-save-button disabled" : "preset-save-button"}>
                  Save
                </div>
              </div>
            </div>
        );
    }

    let createdBy = '';
    if (content.isCreated() && content.getContentType() === SAMPLE) {
        createdBy = (
            <div className="sampled-by">
              <span className="sample-finder">{userName}</span> {creationWord} this on <span className="sampled-date">{createdDate}</span>
            </div>);

    }
    return (
        <div className="created-by">
          {creation}
          {createdBy}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateBy);
